import HTTPClient from '@elab/core/utils/HTTPClient';
import cartApi from '@elab/core/store/cart/api';

const setBillingAddress = async (userId, cartId, addressDto, isEgiftCardCartActive = false) => {
    const uri = `${cartApi.getCurrentCartApiService(
        userId,
        cartId,
        isEgiftCardCartActive,
    )}/addresses/billing`;
    const response = await HTTPClient().postJson(uri, addressDto);

    if (!response.ok) {
        throw {
            json: await response.json(),
            status: response.status,
            message: response.message,
        };
    }
};

export default {
    setBillingAddress,
};
